import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

const GiveReview = () => {
    const { register, handleSubmit, reset } = useForm();
    const [alert, setAlert] = useState(false);
    const onSubmit = data => {
        fetch('https://infinite-river-22082.herokuapp.com/reviews', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(data => {
                if (data.insertedId) {
                    setAlert(true);
                    reset();
                }
            })
    };
    return (
        <div className='container'>
            <h2 className='text-center title'>Put A Review! 🚀</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <label style={{ fontFamily: 'Poppins', marginRight: '10px' }} htmlFor="">Your Name: </label>
                <input className='m-3' {...register("name")} required />
                <br />
                <label style={{ fontFamily: 'Poppins', marginRight: '10px' }} htmlFor="">Your Review: </label>
                <br />
                <textarea className='m-3' {...register("review")} required />
                <br />
                <label style={{ fontFamily: 'Poppins', marginRight: '10px' }} htmlFor="">Your Rating: </label>
                <select {...register("rating")} required>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
                <br />
                <input style={{ fontFamily: 'Poppins', marginTop: '30px', backgroundColor: 'black', color: 'white', border: 'none', padding: '10px', borderRadius: '10px' }} type="submit" value='Put Review ❤' />
            </form>
            {
                alert && <div style={{ fontFamily: 'Poppins' }} className="alert alert-success m-3 w-50" role="alert">
                    Thanks for your review! ❤
                </div>
            }

        </div>
    );
};

export default GiveReview;